module.exports = __webpack_public_path__ + "img/mgfu-energiatamogatas.6805b01b.png";